/**
 * Transaction type enum to ensure consistency across the application
 */
export const TransactionType = {
  BUY: 'BUY',
  SELL: 'SELL',
  TRANSFER_IN: 'TRANSFER_IN',
  TRANSFER_OUT: 'TRANSFER_OUT',
  INTERNAL_TRANSFER: 'INTERNAL_TRANSFER',
  SPLIT: 'SPLIT',
  
  // Helper to get display name
  getDisplayName: function(type) {
    switch (type) {
      case this.BUY:
        return 'Buy';
      case this.SELL:
        return 'Sell';
      case this.TRANSFER_IN:
        return 'Transfer In';
      case this.TRANSFER_OUT:
        return 'Transfer Out';
      case this.INTERNAL_TRANSFER:
        return 'Internal Transfer';
      case this.SPLIT:
        return 'Stock Split';
      default:
        return type;
    }
  },
  
  // Helper to get type color
  getTypeColor: function(type) {
    switch (type) {
      case this.BUY:
        return 'text-green-600 dark:text-green-500';
      case this.SELL:
        return 'text-red-600 dark:text-red-500';
      case this.TRANSFER_IN:
        return 'text-blue-600 dark:text-blue-400';
      case this.TRANSFER_OUT:
        return 'text-orange-600 dark:text-orange-400';
      case this.INTERNAL_TRANSFER:
        return 'text-purple-600 dark:text-purple-400';
      case this.SPLIT:
        return 'text-purple-600 dark:text-purple-400';
      default:
        return '';
    }
  },
  
  // Helper to check if type is a transfer
  isTransfer: function(type) {
    return type === this.TRANSFER_IN || type === this.TRANSFER_OUT || type === this.INTERNAL_TRANSFER;
  }
}; 